// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thm-container {
  width: 100%;
  max-width: 1200px;
  padding-left: 15px;
  padding-right: 15px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.comparePolicyScreenTopHeading {
  background-color: #424e71;
  color: #fff;
  padding: 10px 0px;
  text-align: left;
  border: 1px solid #323c5a;
}
.text-center {
  text-align: center !important;
}
.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.compareDetailssection {
  background-color: #fff;
}
.compareDetailssectionleft,
.compareDetailssectionright {
  border: 1px solid #dfdfdf;
  padding-top: 10px;
  padding-bottom: 10px;
}
.compareDetailssectionleft .compareP {
  margin-left: 25px;
}
.compareDetailssectionleftbox:last-child {
  border-bottom: 0px solid #d2d2d2;
}
.comparepagesLastDiv {
  text-align: center;
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
.mx-auto {
  margin-left: auto !important;
}
.d-block {
  display: block !important;
}
.compareDetailssection p {
  margin: 0px;
  padding: 0px;
}
b,
strong {
  font-weight: bolder;
}
.comparepagesLastDiv {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/SidebarComponent/RelianceGeneral/RGIPoliciesKYC.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".thm-container {\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  display: block;\r\n}\r\n.comparePolicyScreenTopHeading {\r\n  background-color: #424e71;\r\n  color: #fff;\r\n  padding: 10px 0px;\r\n  text-align: left;\r\n  border: 1px solid #323c5a;\r\n}\r\n.text-center {\r\n  text-align: center !important;\r\n}\r\n.col-form-label {\r\n  padding-top: calc(0.375rem + 1px);\r\n  padding-bottom: calc(0.375rem + 1px);\r\n  margin-bottom: 0;\r\n  font-size: inherit;\r\n  line-height: 1.5;\r\n}\r\n\r\n.compareDetailssection {\r\n  background-color: #fff;\r\n}\r\n.compareDetailssectionleft,\r\n.compareDetailssectionright {\r\n  border: 1px solid #dfdfdf;\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n}\r\n.compareDetailssectionleft .compareP {\r\n  margin-left: 25px;\r\n}\r\n.compareDetailssectionleftbox:last-child {\r\n  border-bottom: 0px solid #d2d2d2;\r\n}\r\n.comparepagesLastDiv {\r\n  text-align: center;\r\n}\r\n.img-fluid {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n.mx-auto {\r\n  margin-left: auto !important;\r\n}\r\n.d-block {\r\n  display: block !important;\r\n}\r\n.compareDetailssection p {\r\n  margin: 0px;\r\n  padding: 0px;\r\n}\r\nb,\r\nstrong {\r\n  font-weight: bolder;\r\n}\r\n.comparepagesLastDiv {\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
